module.exports = __webpack_public_path__ + "static/media/loader.6027e007.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/WaitForState/svgs/loader.svg
// module id = 161
// module chunks = 0